import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Content, Section, Title, TitleTwo, TitleGroup } from "../../AppStyle";
import images from "./Images";
import { useEffect, useState } from "react";

const Work = () => {
  const [img, setImg] = useState<any>();

  useEffect(() => {
    setImg(images);
  }, []);

  return (
    <Section
      style={{ boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)" }}
      id="work"
      color="#F9F9F9"
    >
      <Content>
        <div
          className="responsive-work"
          style={{ width: 600, margin: "0 auto", textAlign: "center" }}
        >
          <TitleGroup>
            <Title>Our</Title>
            <TitleTwo>&nbsp;Work</TitleTwo>
          </TitleGroup>
          <div style={{ marginBottom: 40, padding: "0px 10px" }}>
            P&B allows you to choose from any door style, any combination of
            materials, hardware and finishes. For both new construction,
            remodels or commercial projects.
          </div>
          <Carousel>
            {img ? (
              img.map((item: any, i: any) => {
                return (
                  <div key={`${item}_${i}`}>
                    <img src={img[i].default} alt={`Img_${i}`} />
                  </div>
                );
              })
            ) : (
              <div></div>
            )}
          </Carousel>

          <div style={{ fontWeight: 700, color: "#951211", marginBottom: 10 }}>
            CUSTOMER SATISFACTION GUARANTEED
          </div>
          <div style={{ marginBottom: 30, padding: "0px 10px" }} id="contact">
            We will always strive to save you time and money by using our
            cabinet experience, the highest quality of parts and our dedication
            to meet deadlines and deliver exceptional service.
          </div>
        </div>
      </Content>
    </Section>
  );
};

export default Work;
